import React, {Component} from 'react';
import {connect} from 'react-redux';
import {ScreenNotificationDefault} from '../../components';
import {preAvaliacaoSolicitar} from '../../ducks/Customer';
import {redirectToProcessingPreEvaluation} from '../../ducks/Navigate';
import {parametroSistemaBuscar} from '../../ducks/SystemParameter';
import {ParamKeys, RouteKeys} from '../../constants';
import {StringService} from '../../services';

import './styles.scss';
class RemakePreEvaluation extends Component {
  state = {
    codigo: '',
    currentCount: 0,
    intervalId: '',
  };

  async componentDidMount() {
    document.title = StringService.formatTitle(
      RouteKeys.RemakePreEvaluation.title,
    );

    await this.props.parametroSistemaBuscar(
      ParamKeys.PARAMETRO_SISTEMA_REFAZER_PREAVALIACAO_SEGUNDOS,
    );
    this.resend();
  }

  timer = () => {
    var newCount = this.state.currentCount - 1;
    if (newCount >= 0) {
      this.setState({currentCount: newCount});
    } else {
      clearInterval(this.state.intervalId);
    }
  };

  resend = () => {
    this.setState({currentCount: parseInt(this.props.valor)});
    var intervalId = setInterval(this.timer, 1000);
    this.setState({intervalId: intervalId});
  };

  componentWillUnmount() {
    clearInterval(this.state.intervalId);
  }

  handle = () => {
    this.props.redirectToProcessingPreEvaluation();
  };

  render() {
    return (
      <ScreenNotificationDefault
        title={<p>Análise não concluída</p>}
        contentCustom={
          <div className="remake-pre-evaluation">
            <p>
              Ocorreu um erro inesperado e não foi possível concluir a sua
              análise no momento.
            </p>
            <br />
            <br />
            {this.state.currentCount > 0 && (
              <p>
                Por favor tente novamente em {this.state.currentCount} segundos.
              </p>
            )}
            <br />
            <br />
            {this.state.currentCount === 0 && (
              <div className="button-container">
                <button className="button" onClick={this.handle}>
                  Reenviar
                </button>
              </div>
            )}
          </div>
        }
        contentButtons={<div className="div-data-contact"></div>}
      />
    );
  }
}

const mapStateToProps = ({systemParameter}) => {
  const {valor} = systemParameter;
  return {valor};
};
export default connect(mapStateToProps, {
  preAvaliacaoSolicitar,
  redirectToProcessingPreEvaluation,
  parametroSistemaBuscar,
})(RemakePreEvaluation);
